// src/components/Header.jsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const Header = ({ title, onToggleSidebar }) => {
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();

  // Get user initials for avatar fallback
  const getUserInitials = () => {
    if (!user || !user.email) return 'G';
    return user.email.substring(0, 2).toUpperCase();
  };

  return (
    <header className="header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <button 
          onClick={onToggleSidebar}
          className="sidebar-toggle"
          title="Toggle Navigation Menu"
          type="button"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-secondary)',
            cursor: 'pointer',
            padding: '0.5rem',
            borderRadius: '50%',
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all var(--transition-fast)'
          }}
        >
          <svg style={{ width: '22px', height: '22px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        <div className="header-title">
          <h1>{title}</h1>
        </div>
      </div>
      <div className="header-right">
        <button 
          onClick={toggleTheme} 
          className="theme-toggle" 
          title="Toggle Light/Dark Theme"
          type="button"
        >
          {theme === 'light' ? (
            <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
            </svg>
          ) : (
            <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m0-12.728l.707.707m12.728 12.728l.707.707M12 8a4 4 0 100 8 4 4 0 000-8z"></path>
            </svg>
          )}
        </button>

        {user && (
          <div className="user-profile-menu">
            <div className="user-avatar">
              {getUserInitials()}
            </div>
            <div className="user-info">
              <span className="user-name">{user.email}</span>
              <span className="user-role">{user.role_name}</span>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
